import { camelCaseResponse } from "../shared/Functions";
import { emptyApi } from "./emptyApi";

export const movementsExtendedApi = emptyApi.injectEndpoints({
  endpoints: (builder) => ({
    getFailedMovements: builder.query<
      any[],
      {
        sessionId: string;
        offset: number;
        limit: number;
        orgPlayerId?: string;
      }
    >({
      query: (args) => {
        const { sessionId, offset, limit, orgPlayerId } = args;
        const params: any = {
          session_id: sessionId,
          offset,
          limit,
        };
        if (orgPlayerId) {
          params.org_player_id = orgPlayerId;
        }
        return {
          url: "/failed_movements",
          params,
        };
      },
      transformResponse: (response: any) => camelCaseResponse(response),
    }),
  }),
});

export const { useGetFailedMovementsQuery } = movementsExtendedApi;
